var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2601 13.7788H4.73991C2.84633 13.7788 1.31128 15.3139 1.31128 17.2074V32.7921C1.31128 34.6857 2.84633 36.2208 4.73991 36.2208H45.2601C47.1537 36.2208 48.6888 34.6857 48.6888 32.7921V17.2074C48.6888 15.3139 47.1537 13.7788 45.2601 13.7788Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7896 29.2944C13.094 28.9902 13.5067 28.8193 13.9371 28.8193C14.3674 28.8193 14.7802 28.9902 15.0846 29.2944",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92041 26.4255C10.986 25.3608 12.4308 24.7627 13.9371 24.7627C15.4435 24.7627 16.8882 25.3608 17.9539 26.4255",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05078 23.556C8.87777 21.7308 11.3546 20.7056 13.9371 20.7056C16.5196 20.7056 18.9965 21.7308 20.8234 23.556",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5693 29.2944C35.8738 28.9902 36.2865 28.8193 36.7169 28.8193C37.1472 28.8193 37.56 28.9902 37.8644 29.2944",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7002 26.4255C33.7658 25.3608 35.2106 24.7627 36.7169 24.7627C38.2233 24.7627 39.668 25.3608 40.7337 26.4255",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8306 23.556C31.6576 21.7308 34.1344 20.7056 36.7169 20.7056C39.2994 20.7056 41.7762 21.7308 43.6032 23.556",
    stroke: "#D0B05D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35.8052V13.7788",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4385 21.4438L35.4536 29.4037",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon-02.1aa7c0d869fdf04ccad53c2d6126ad39.svg";
export { ForwardRef as ReactComponent };